import ClickableCard from "../../../Components/Cards/ClickableCard";
import PropTypes from 'prop-types';
import { Box, Grid, Typography, Chip, useTheme } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import ProscoreShield from "../../../Assets/Icons/apple-touch-icon.png";
import GenericModal from "../../../Components/Modals/GenericModal";
import { useState } from "react";

const CardBody = ({ total, available, chipText, title, tableComponent,fetchAllComplianceDocument }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const theme = useTheme();

  // Trim the title to remove any special characters for data-testid
  // This is to ensure that the data-testid is clean and does not contain spaces or special characters
  let trimedTitleText = title.replace(/[^a-zA-Z0-9]/g, "").trim();
  return (
    <>
      {available < total ? (
        <Cancel color="error" style={{ width: "69px", height: "69px", marginBottom: "10px" }} />
      ) : (
        <img src={ProscoreShield} style={{ width: "69px", height: "69px", marginBottom: "10px" }} />
      )}
      <Typography className="chip-container project-proportion" data-testid={`compliance-tile-count-${trimedTitleText}`}>
        {chipText?.length > 0 && (
          <Chip
            data-test-id={"required-count"}
            label={chipText}
            sx={{ fontSize: "16px", fontWeight: "600", marginBottom: "15px", color: theme.palette.text.chip }}
          />
        )}
      </Typography>
      <Typography
        className="card-title"
        data-test-id={`compliance-navigator-card-${trimedTitleText}`}
        sx={{ textDecoration: "underline", cursor: "pointer", fontSize: "20px", fontWeight: "600", color: theme.palette.text.title }}
        onClick={handleOpen}
      >
        {title}
      </Typography>
      <GenericModal modalTitle={title} modalDescription={"hello"} open={open} setOpen={setOpen} onCloseAction={fetchAllComplianceDocument}>
        {tableComponent()}
      </GenericModal>
    </>
  );
};

CardBody.propTypes = {
  total: PropTypes.number,
  available: PropTypes.number,
  chipText: PropTypes.string,
  title: PropTypes.string,
  tableComponent: PropTypes.func,
};

const ComplianceNavigatorCards = ({ cards, toggleSelectedCards, selectedCards,fetchAllComplianceDocument }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={1} direction="row">
        {cards.map((card, idx) => {
          let isSelected = selectedCards.includes(card.title);
          return (
            <Grid item xs={4} sm={4} md={4} key={`compliance-nav-card-${idx}`}>
              <ClickableCard
                isSelected={isSelected}
                style={{ height: '100%' }}
                checkbox_id={card.title.split(" ").join("_").toLowerCase()}
                hideCheckbox={card.hideCheckbox}
                onChangeAction={() => toggleSelectedCards(card.title)}
              >
                <CardBody {...card} fetchAllComplianceDocument={fetchAllComplianceDocument}/>
              </ClickableCard>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

ComplianceNavigatorCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      total: PropTypes.number,
      available: PropTypes.number,
      chipText: PropTypes.string,
      title: PropTypes.string,
      tableComponent: PropTypes.func,
      hideCheckbox: PropTypes.bool
    })
  ),
  toggleSelectedCards: PropTypes.func,
  selectedCards: PropTypes.arrayOf(PropTypes.string),
};

export default ComplianceNavigatorCards;
